import { z } from "zod";

export const UserSchema = z.object({
  id: z.union([z.string(), z.number()]),
  email: z.string().email(),
  name: z.string().nullable().optional(),
  role: z.number().nullable().optional(),
  phone: z.string().nullable().optional(),
  created_at: z.string().optional(),
  updated_at: z.string().optional(),
  active: z.boolean().optional(),
  // z.object strips unknown keys, so every field the app reads off the stored
  // user must be declared here or it silently vanishes after safeParse.
  user_type: z.string().optional(),
  department: z.string().nullable().optional(),
  notification_preferences: z
    .object({
      mute_all: z.boolean().optional(),
      email: z.boolean().optional(),
      sms: z.boolean().optional(),
      push: z.boolean().optional(),
    })
    .passthrough()
    .nullable()
    .optional(),
}).superRefine((user, ctx) => {
  if (user.user_type !== 'public' && typeof user.role !== 'number') {
    ctx.addIssue({ code: z.ZodIssueCode.custom, path: ['role'], message: 'Staff role is required' });
  }
});
